export const environment = {
     production: false,
  apiBaseUrl: 'https://pinkyauradevapi.ape-org.com/api',
  imageApiBaseUrl: 'https://pinkyauradevapi.ape-org.com'   
  /*  production: false,
  apiBaseUrl: 'https://localhost:7256/api',
  imageApiBaseUrl: 'https://localhost:7256'   */
};
